import _ from "lodash";
export const selectProfile = ({ ToolBoxProfile_reducer }) => {
    return ToolBoxProfile_reducer.profile;
};
export const selectCurrentUser = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) {
        let user_name =
            _.get(UserProfile_reducer.profile.profile, "first_name") +
            " " +
            _.get(UserProfile_reducer.profile.profile, "last_name");
        let uid = _.get(UserProfile_reducer.profile.profile, "uid");

        return { user_name, uid };
    } else return false;
};
export const getRequesting = ({ ToolBoxProfile_reducer }) => {
    return ToolBoxProfile_reducer.requesting;
};
export const selectNewToolboxID = ({ ToolBoxProfile_reducer }) => {
    return ToolBoxProfile_reducer.newToolboxID;
};
export const getUserIcons = ({ MainReducer }) => {
    if (MainReducer.users) {
        let users = {};
        Object.keys(MainReducer.users).map((e) => {
            users = _.assign(users, {
                [e]: MainReducer.users[e].profile.profile_image_url,
            });
            return null;
        });
        return users;
    } else return false;
};
export const selectToolType = ({ ToolBoxProfile_reducer }) => {
    return ToolBoxProfile_reducer.toolboxTypes
        ? Object.keys(ToolBoxProfile_reducer.toolboxTypes).map(
              (e) => ToolBoxProfile_reducer.toolboxTypes[e]
          )
        : [];
};
